import { render, staticRenderFns } from "./sperrzeit-datum-feld.vue?vue&type=template&id=1675ddd9&scoped=true"
import script from "./sperrzeit-datum-feld.vue?vue&type=script&lang=js"
export * from "./sperrzeit-datum-feld.vue?vue&type=script&lang=js"
import style0 from "./sperrzeit-datum-feld.vue?vue&type=style&index=0&id=1675ddd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675ddd9",
  null
  
)

export default component.exports